import { handleColorType } from '@quizzach/styles';
import { useTheme } from 'styled-components';

export const ArrowLeft = ({
	color,
	size,
	className,
}: {
	color?: string;
	size?: number;
	className?: string;
}) => {
	const theme = useTheme();

	return (
		<svg
			width={size || '42'}
			height={size || '42'}
			viewBox='0 0 42 42'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<path
				d='M1.29289 20.2929L7.65685 13.9289C8.04738 13.5384 8.68054 13.5384 9.07107 13.9289C9.46159 14.3194 9.46159 14.9526 9.07107 15.3431L4.41422 20H40C40.5523 20 41 20.4477 41 21C41 21.5523 40.5523 22 40 22H4.41422L9.07107 26.6568C9.46159 27.0474 9.46159 27.6805 9.07107 28.0711C8.68054 28.4616 8.04738 28.4616 7.65685 28.0711L1.29289 21.7071C0.90237 21.3166 0.90237 20.6834 1.29289 20.2929Z'
				fill={color ? handleColorType(color, theme) : '#00FFC2'}
			/>
		</svg>
	);
};
